export type ContentState = {
  contentIsLoading: boolean;
};

export const Mutation_setContentIsLoading = 'setContentIsLoading';

export const state: ContentState = {
  contentIsLoading: false,
};

export const mutations = {
  [Mutation_setContentIsLoading](state: ContentState, loading: boolean) {
    state.contentIsLoading = loading;
  },
};
